import { put, call, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* sendReferralInvitation({ payload: { values, onSuccess, handledErrors }  }) {
  try {
    const { data } = yield call(fetch, { api: api.refer.invite, data: { email_addresses: values } });

    onSuccess && onSuccess();

    yield put(actions.sendReferralInvitationDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.sendReferralInvitationFailed,
      handledErrors,
      endpoint: api.refer.invite.url
    });
  }
}

export const sendReferralInvitationSaga = takeEvery(types.SEND_REFERRAL_INVITATION_REQUEST, sendReferralInvitation);